(function () {
  function enhance(root) {
    root.querySelectorAll('.mega-menu__list > li > div').forEach(function (div) {
      if (div.dataset.acc) return;
      var a = div.querySelector(':scope > a.mega-menu__link--parent');
      var ul = div.querySelector(':scope > ul');
      if (!a || !ul) return;
      div.dataset.acc = '1';
      var head = document.createElement('div');
      head.className = 'mega-menu__acc-head';
      div.insertBefore(head, a);
      head.appendChild(a);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mega-menu__acc-toggle';
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-label', 'Afficher les sous-catégories : ' + a.textContent.trim());
      b.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      head.appendChild(b);
      ul.classList.add('mega-menu__acc-list');
      ul.hidden = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        ul.hidden = open;
      });
    });
  }
  function run() { enhance(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function () { enhance(document); }).observe(document.documentElement, { childList: true, subtree: true });
})();
